var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactModal from 'react-modal';
import { useHistory } from 'react-router-dom';
export const ResourceModal = (_a) => {
    var { children, onClose, isOpen, actionButtons } = _a, props = __rest(_a, ["children", "onClose", "isOpen", "actionButtons"]);
    const history = useHistory();
    const handleClose = () => {
        history.replace('/');
        onClose();
    };
    return (React.createElement(ReactModal, Object.assign({ className: "EventModal__contentContainer", overlayClassName: "EventModal__overlay", ariaHideApp: false, onRequestClose: handleClose, isOpen: isOpen }, props),
        React.createElement("div", { className: "EventModal__box" },
            React.createElement("div", { className: "EventModal__closeContainer" },
                React.createElement("button", { className: 'EventModal__closeButton', onClick: handleClose },
                    React.createElement("span", { className: 'EventModal__closeButtonLabel' }, "Close"))),
            React.createElement("div", { className: "EventModal__layoutContainer" }, children),
            actionButtons &&
                React.createElement("div", { className: "EventModal__actionContainer" }, actionButtons))));
};
